// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1MHJf","log":"ModalInventoryLogs_log__2UjfY","date":"ModalInventoryLogs_date__X1kIB","userName":"ModalInventoryLogs_userName__NEKMY"};